<template>
  <div class="logo-bar">
    <div
      class="inner"
      :style="{
        width: `${width}px`
      }"
    >
      <img class="logo" :style="{height: logoHeight}" :src="logo" />
      <div class="qrcode-module">
        <qrcode class="code" :value="qrcode" :options="{ size: 70 }"></qrcode>
        <div class="tips">
          <img
            class="mobile-icon"
            src="@/assets/images/common/mobile-icon.png"
          />
          <p>扫码关注</p>
          <p>了解更多</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import qrcode from "@xkeshi/vue-qrcode";
export default {
  props: {
    width: {
      type: Number,
      default: 1200
    },
    logo: {
      type: String,
      default: ""
    },
    logoHeight: {
      type: String,
      default: '100%'
    },
    padding: {
      type: Number,
      default: 0
    },
    qrcode: {
      type: String,
      default: ""
    }
  },
  components: {
    qrcode
  },
  data() {
    return {};
  }
};
</script>

<style scoped lang="scss">
.logo-bar {
  width: 100%;
  height: 110px;
  text-align: center;
  .inner {
    height: 100%;
    display: inline-flex;
    justify-content: space-between;
    align-items: center;
    .logo {
      width: auto;
    }
    .qrcode-module {
      display: flex;
      align-items: center;
      .code {
        margin-right: 10px;
        width: 70px;
        height: 70px;
      }
      .tips {
        text-align: center;
        font-size: 12px;
        .mobile-icon {
          display: inline-block;
          width: 14px;
          height: 22px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/logoBar/index.vue